import { useEffect, useSyncExternalStore } from 'react';

// DevShell mounts outside the app router, so pages signal through this
// module-level store instead of route context.
let chromeHidden = false;
const listeners = new Set<() => void>();

function setChromeHidden(next: boolean) {
  if (chromeHidden === next) return;
  chromeHidden = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return chromeHidden;
}

export function useDevShellChromeHidden() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

/** Hides the dev-shell header and sidebar while the calling component is mounted. */
export function useDevShellFullscreen() {
  useEffect(() => {
    setChromeHidden(true);
    return () => setChromeHidden(false);
  }, []);
}
